export const DATE_TIME_CONSTANT_FORMAT = 'yyyy-MM-dd : HH:mm (O)';